import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { faqs, forYou, notDesignedTo } from '../../data/content';
export function ForYouAndFaq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper-50 px-5 py-14 sm:px-8 sm:py-20" data-id="element-157" data-mp="7ii8xd6manht">
      <div className="mx-auto max-w-4xl" data-id="element-158" data-mp="3hpzojxqwilj">
        <SectionHeading tone="light" title="Is the Master System of TRT™ for You?" data-id="element-159" data-mp="3ird2v28hh6f" />

        <div className="mt-8 grid gap-4 lg:grid-cols-2" data-id="element-160" data-mp="3um69kk0w4v0c">
          <div className="rounded-2xl border border-teal-500/30 bg-white p-5 sm:p-6" data-id="element-161" data-mp="3po4ojtjwmlm8">
            <h3 className="font-display text-lg font-bold uppercase tracking-[0.08em] text-teal-700 sm:text-xl" data-id="element-162" data-mp="3kptfhl1fof52">
              Yes — if you want to:
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-163" data-mp="1nwi46auipoyq">
              {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-164" data-mp="1iyq2ip42mohc">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-500" data-id="element-165" data-mp="1g48j5xwxzclg">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-166" data-mp="1l4coqswbamww" />
                  </span>
                  <span className="text-sm font-medium leading-snug text-ink-900 sm:text-base" data-id="element-167" data-mp="167vgiajf5oek">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-paper-200 bg-white p-5 sm:p-6" data-id="element-168" data-mp="1yx2p62cl7udj">
            <h3 className="font-display text-lg font-bold uppercase tracking-[0.08em] text-ink-600 sm:text-xl" data-id="element-169" data-mp="23tj9elgo1olc">
              It’s not designed to:
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-170" data-mp="1u3hmvy3yoe8j">
              {notDesignedTo.map(item => <li key={item} className="flex items-start gap-3" data-id="element-171" data-mp="2htc2uojkuix0">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-paper-200" data-id="element-172" data-mp="2hs0v6dn0gr0m">
                    <XIcon className="h-3.5 w-3.5 text-ink-600" aria-hidden="true" data-id="element-173" data-mp="2wgascdyvj393" />
                  </span>
                  <span className="text-sm leading-snug text-ink-600 sm:text-base" data-id="element-174" data-mp="2rgy0fet5b5zn">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <h3 className="mt-14 text-center font-display text-2xl font-bold uppercase tracking-tight text-ink-900 sm:text-3xl" data-id="element-175" data-mp="2igrt6ao1j28x">
          Frequently Asked Questions
        </h3>

        <ul className="mt-6 space-y-2.5" data-id="element-176" data-mp="2djroo46ua7jx">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-paper-200 bg-white" data-id="element-177" data-mp="23rdk73odmmu2" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-paper-100" data-id="element-178" data-mp="1zr31cqfhk1xs">
                  <span className="text-[15px] font-bold leading-snug text-ink-900 sm:text-base" data-id="element-179" data-mp="59jrcduf9ddy">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-teal-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-180" data-mp="f8iu5fsiaet1" />
                </button>
                {isOpen ? <p className="border-t border-paper-200 px-4 py-4 text-sm leading-relaxed text-ink-600 sm:text-[15px]" data-id="element-181" data-mp="3noufhfnkfctm">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-md" data-id="element-182" data-mp="2zygidaq4ins6">
          <CtaButton label="Get the Master System of TRT™" subLabel="Instant Digital Access · USD 27 · 7-Day Guarantee" data-id="element-183" data-mp="2zxoz8zdpqiis" />
        </div>
      </div>
    </section>;
}